import _ from 'lodash'
const SITE_HEADER_CONFIG = {
    header: _.select( '.c-site-header' ),
    nav: _.select( '.c-site-nav' ),
    hamburger: _.select( '.c-site-header .hamburger' ),
    mobileBg: _.select( '.c-site-nav' )
}

export default SITE_HEADER_CONFIG